import { Clock, Flame, Users } from "lucide-react";

/**
 * Static showcase card mirroring the look of a real cleaned recipe.
 * Uses the same tokens/typography as RecipeCard so users see what they'll get.
 */
export const MockRecipeCard = () => {
  return (
    <div className="mx-auto w-full max-w-2xl overflow-hidden rounded-2xl bg-card shadow-card ring-1 ring-border">
      <div className="space-y-6 p-6 sm:p-10">
        <header className="space-y-3">
          <h3 className="recipe-title font-display text-3xl font-semibold leading-tight text-foreground sm:text-4xl">
            One-pan lemon chicken with herbs
          </h3>
          <div className="flex flex-wrap gap-2">
            {["Dinner", "One-pan", "Quick", "Comfort food"].map((t) => (
              <span
                key={t}
                className="rounded-full bg-accent px-2.5 py-0.5 text-xs font-medium text-accent-foreground"
              >
                {t}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1.5">
              <Clock className="h-3.5 w-3.5" /> 10 mins prep
            </span>
            <span className="inline-flex items-center gap-1.5">
              <Flame className="h-3.5 w-3.5" /> 25 mins cook
            </span>
            <span className="inline-flex items-center gap-1.5">
              <Users className="h-3.5 w-3.5" /> Serves 4
            </span>
          </div>
        </header>

        <div className="grid gap-8 md:grid-cols-[1fr_1.4fr]">
          <section>
            <h4 className="mb-3 font-display text-lg font-semibold text-foreground">
              Ingredients
            </h4>
            <ul className="recipe-body space-y-1.5 text-foreground">
              <li>4 chicken thighs, bone-in</li>
              <li>1 tbsp olive oil</li>
              <li>1 lemon, sliced</li>
              <li>3 cloves garlic, crushed</li>
              <li>1 tsp dried oregano</li>
              <li>200 ml chicken stock</li>
              <li>Salt and black pepper</li>
            </ul>
          </section>

          <section>
            <h4 className="mb-3 font-display text-lg font-semibold text-foreground">
              Method
            </h4>
            <ol className="recipe-body space-y-3 text-foreground">
              {[
                "Heat oven to 200°C.",
                "Season chicken with salt and pepper.",
                "Sear chicken skin-side down in olive oil for 4 minutes.",
                "Add garlic, lemon, oregano and stock. Transfer to oven.",
                "Roast for 20 minutes, until chicken is golden and cooked through.",
              ].map((step, i) => (
                <li key={i} className="flex gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">
                    {i + 1}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </section>
        </div>
      </div>
    </div>
  );
};
